// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "svg.atom-icon-help[data-v-69e57b74]{color:#fff;cursor:pointer;font-size:24px}", ""]);
// Exports
module.exports = exports;
